export default __webpack_public_path__ + "static/media/25.dcac90b1.jpg";